import { render, staticRenderFns } from "./Component-NewTask.vue?vue&type=template&id=7ae098b7"
import script from "./Component-NewTask.vue?vue&type=script&lang=js"
export * from "./Component-NewTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports